import React, { ReactElement } from 'react';
import classNames from 'classnames';

import styles from './segmentedSelectorStyles.scss';

interface SegmentedSelectorOption<T extends string | number> {
  label: string | React.JSX.Element;
  value: T;
}

interface SegmentedSelectorProps<T extends string | number> {
  disabled?: boolean;
  onChange: (value: T) => void;
  options: SegmentedSelectorOption<T>[];
  selected: T;
  size?: 'sm' | 'md';
}

const SegmentedSelector = <T extends string | number>({
  disabled = false,
  onChange,
  options,
  selected,
  size = 'md'
}: SegmentedSelectorProps<T>): ReactElement => (
  <div className={classNames(styles.segmentedSelector, styles[size])}>
    {options.map(option => (
      <button
        key={option.value}
        disabled={disabled}
        className={classNames(styles.option, {
          [styles.active]: selected === option.value
        })}
        onClick={() => onChange(option.value)}
        type="button"
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default SegmentedSelector;
